module.exports = __webpack_public_path__ + "img/HoneyMustard.b790c001.webp";